import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Header dell'applicazione con logo e link di navigazione.
 * Utilizza React Router per evidenziare la rotta attiva.
 */
const Header: React.FC = () => {
  const location = useLocation();

  const linkStyle = (path: string): React.CSSProperties => ({
    textDecoration: 'none',
    color: location.pathname === path ? '#ffffff' : '#cbd5e1',
    backgroundColor: location.pathname === path ? '#1e293b' : 'transparent',
    padding: '0.5rem 1rem',
    borderRadius: '0.375rem',
    fontWeight: 500,
    fontSize: '0.9rem',
    transition: 'color 0.2s, background-color 0.2s',
  });

  return (
    <header
      style={{
        backgroundColor: '#0f172a',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0.75rem 1.5rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
          </svg>
          <span style={{ fontSize: '1.25rem', fontWeight: 'bold', letterSpacing: '-0.5px' }}>
            V‑Spot
          </span>
        </Link>
        <nav style={{ display: 'flex', gap: '0.5rem' }}>
          <Link to="/" style={linkStyle('/')}>Carica</Link>
          <Link to="/history" style={linkStyle('/history')}>Partite</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;